define('app/views/_b2b_landing_page_view',['app/setup'],
  function(takhfifan) {
  takhfifan._b2bLandingPageView = Backbone.View.extend({
    initialize: function(options) {
      var _this=this;
      var template=null;
      var compiled_template=null;
      var max = 150.72259521484375;
      for(var i=1;i<=4;i++) {
        template = _.template($('#tkh-item-stat'+i+'-template')
          .html().replace("// <![CDATA[", "").replace("// ]]>", ""));
        compiled_template = template({});
        $('#tkh-item-stat'+i).prepend(compiled_template);
      }
      _.delay(function() {
              $.each(this.$('.progress'), function( index, value ){
                $(value).children($('.fill')).attr('style',
                  'stroke-dashoffset: ' + ((100 - $(value).data('progress')) / 100) * max);
                _this.setNum(value,$(value).data('progress'));
              });
      }, 1000);
    },
    setNum: function(value,progress) {
      $(value).children($('.display')).text(progress + '%');
      $(value).find('.display').fadeIn();
    },
    myStopFunction: function(progress) {
      clearInterval(progress);
    }
  });
});

